// Reactive app state with cross-tab sync via BroadcastChannel.

const CHANNEL_NAME = 'bx-support'

const initialState = () => ({
  authReady: false,        // true once the initial session check has resolved
  user: null,              // { id, email, role, fullName, avatarUrl, clientId }
  ticketFilters: {         // landing-list view state (functional-spec §12.5)
    status: null,
    sort: 'last_activity',
    dir: 'desc',
    view: 'mine'
  }
})

let state = initialState()
const listeners = new Set()

let channel
try {
  channel = new BroadcastChannel(CHANNEL_NAME)
  channel.onmessage = (e) => { state = e.data; notify() }
} catch {
  channel = null
}

function notify() {
  listeners.forEach(fn => fn(state))
}

export const store = {
  get() {
    return state
  },

  set(partial) {
    state = { ...state, ...partial }
    notify()
    channel?.postMessage(state)
  },

  clear() {
    state = { ...initialState(), authReady: true }
    notify()
    channel?.postMessage(state)
  },

  subscribe(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
  }
}

// Mixin for Lit components to observe store changes.
export const StoreMixin = (Base) => class extends Base {
  connectedCallback() {
    super.connectedCallback?.()
    this._unsubscribe = store.subscribe(() => this.requestUpdate())
  }

  disconnectedCallback() {
    super.disconnectedCallback?.()
    this._unsubscribe?.()
  }

  get appState() {
    return store.get()
  }
}
